/**
 * Global context for session
 * To access global context: 
 * const { loginStandard, singleSignOn, logout, isLogin, getToken  } = useSession();
 */
import React, { createContext,  useContext } from 'react';
import http from "api/precision/Endpoint";
// Use this for sensitive info like profile, etc

const SessionContext = createContext();

export function SessionProvider({ children }) {

  /**
   * Login by user name and password
   * @param {*} username 
   * @param {*} password 
   * @returns 
   */
  const loginStandard = (email, password, callback) => {
    const loginFormData = new FormData();
    loginFormData.append("method", "standard");
    loginFormData.append("email", email);
    loginFormData.append("password", password);

    http().post("/auth", loginFormData)
    .then( (res) => {
      if (res.data.result == 1) {
        sessionStorage.setItem("profile", JSON.stringify(res.data.profile));
        sessionStorage.setItem("token", res.data.token);
        // Loading user Cart
        sessionStorage.setItem('cartItems', JSON.stringify(res.data.cartItems));
        sessionStorage.setItem("customer", JSON.stringify(res.data.customer));
        callback(true)
      }
      else {
        callback(false);
      }
    })
    .catch((error) => {
      console.log(error);
      callback(false);
    });
  }

  /**
   * Refresh token in amount of time in ms
   * @param int timer 
   */
  const refreshToken = (timer) => {
    setTimeout(() => {
      loginStandard();
    }, timer);
  }

  const logout = () => {
    sessionStorage.removeItem('profile');
    sessionStorage.removeItem('cartOptions');
    sessionStorage.removeItem('customer');
    sessionStorage.removeItem('token');
  }

  /**
   * Check if user login
   * @returns boolean
   */
  const isLogin = () => {
    const str = sessionStorage.getItem('profile');
    return str? true : false;
  }

  /**
   * @returns {*} user profile
   */
  const getProfile = () => {
    const str = sessionStorage.getItem('profile');
    return JSON.parse(str);
  }

  const getCustomer = () => {
    const str = sessionStorage.getItem('customer');
    return JSON.parse(str);
  }

  const saveProfile = (profile) => {
    sessionStorage.setItem("profile", JSON.stringify(profile));
  }

  return (
    <SessionContext.Provider
      value={{
        loginStandard,
        logout,
        isLogin,
        refreshToken,
        getProfile,
        getCustomer,
        saveProfile
      }}
    >
      {children}
    </SessionContext.Provider>
  );
}

export function useSession() {
  return useContext(SessionContext);
}
